import { cj } from 'src/utils/classNames';
import { WithChildren } from 'src/utils/UtilityTypes';
import {
	TOAST_SHADOW_CLASSNAME,
	TOAST_ROUNDED_CLASSNAME,
	TOAST_WIDTH_CLASSNAME,
} from 'src/components/Toasts/consts';
import XButton from 'src/components/Buttons/XButton';
import { Z_INDEX } from 'src/constants/zIndex';
import { USER_SURVEY_TITLE_CLASSNAME } from 'src/components/UserSurvey/consts';

interface Props extends WithChildren {
	title: string;
	onClose: () => void;
}

export default function UserSurveyToast({ title, onClose, children }: Props) {
	return (
		<div
			className={cj(
				'absolute right-sm bottom-9 bg-container-bg text-text-default',
				'flex flex-col gap-y-lg border border-stroke-divider p-lg',
				TOAST_WIDTH_CLASSNAME,
				TOAST_SHADOW_CLASSNAME,
				TOAST_ROUNDED_CLASSNAME,
				Z_INDEX.toastList
			)}
		>
			<div
				className={cj(
					'flex items-center justify-between',
					USER_SURVEY_TITLE_CLASSNAME
				)}
			>
				{title}
				<XButton size="sm" onClick={onClose} />
			</div>

			{children}
		</div>
	);
}
